// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table > thead > tr > th[data-v-146ace26],
.table > tbody > tr > th[data-v-146ace26],
.table > tfoot > tr > th[data-v-146ace26],
.table > thead > tr > td[data-v-146ace26],
.table > tbody > tr > td[data-v-146ace26],
.table > tfoot > tr > td[data-v-146ace26] {
  padding: 0;
  border: none;
}
td > input[data-v-146ace26] {
  min-width: 5em;
}
.table > thead > tr > th[data-v-146ace26] {
  padding-left: 1em;
}
td > button.btn[data-v-146ace26] {
  margin: 0;
  border-radius: 0;
}
legend[data-v-146ace26] {
  background: #ffffff;
  width: auto;
  margin: auto auto 10px auto;
  padding: 5px 15px;
  cursor: pointer;
  font-weight: normal;
}
.btn .icon[data-v-146ace26] {
  line-height: initial;
  vertical-align: baseline;
}
[data-v-146ace26] .htmlContent {
  text-align: initial;
  color: initial;
  outline: none !important;
  padding: 10px;
  background: #ffffff;
  border: 1px dashed #bbbbbb;
  border-radius: 0.25rem;
  width: 100%;
}
[data-v-146ace26] .htmlContent p:last-of-type {
  margin-bottom: 0;
}
caption[data-v-146ace26] {
  caption-side: top;
}
`, "",{"version":3,"sources":["webpack://./admin/pages/Tenant/Edit.3.vue","webpack://./../Edit.3.vue"],"names":[],"mappings":"AACA;;;;;;EAMI,UAAA;EACA,YAAA;ACAJ;ADEA;EACI,cAAA;ACAJ;ADEA;EACI,iBAAA;ACAJ;ADEA;EACI,SAAA;EACA,gBAAA;ACAJ;ADEA;EACI,mBAAA;EACA,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;ACAJ;ADEA;EACI,oBAAA;EACA,wBAAA;ACAJ;ADEA;EACI,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,WAAA;ACAJ;ADRA;EAWQ,gBAAA;ACAR;ADGA;EACI,iBAAA;ACDJ","sourcesContent":["\n.table > thead > tr > th,\n.table > tbody > tr > th,\n.table > tfoot > tr > th,\n.table > thead > tr > td,\n.table > tbody > tr > td,\n.table > tfoot > tr > td {\n    padding: 0;\n    border: none;\n}\ntd > input {\n    min-width: 5em;\n}\n.table > thead > tr > th {\n    padding-left: 1em;\n}\ntd > button.btn {\n    margin: 0;\n    border-radius: 0;\n}\nlegend {\n    background: #ffffff;\n    width: auto;\n    margin: auto auto 10px auto;\n    padding: 5px 15px;\n    cursor: pointer;\n    font-weight: normal;\n}\n.btn .icon {\n    line-height: initial;\n    vertical-align: baseline;\n}\n::v-deep(.htmlContent) {\n    text-align: initial;\n    color: initial;\n    outline: none !important;\n    padding: 10px;\n    background: #ffffff;\n    border: 1px dashed #bbbbbb;\n    border-radius: 0.25rem;\n    width: 100%;\n\n    p:last-of-type {\n        margin-bottom: 0;\n    }\n}\ncaption {\n    caption-side: top;\n}\n",".table > thead > tr > th,\n.table > tbody > tr > th,\n.table > tfoot > tr > th,\n.table > thead > tr > td,\n.table > tbody > tr > td,\n.table > tfoot > tr > td {\n  padding: 0;\n  border: none;\n}\ntd > input {\n  min-width: 5em;\n}\n.table > thead > tr > th {\n  padding-left: 1em;\n}\ntd > button.btn {\n  margin: 0;\n  border-radius: 0;\n}\nlegend {\n  background: #ffffff;\n  width: auto;\n  margin: auto auto 10px auto;\n  padding: 5px 15px;\n  cursor: pointer;\n  font-weight: normal;\n}\n.btn .icon {\n  line-height: initial;\n  vertical-align: baseline;\n}\n::v-deep(.htmlContent) {\n  text-align: initial;\n  color: initial;\n  outline: none !important;\n  padding: 10px;\n  background: #ffffff;\n  border: 1px dashed #bbbbbb;\n  border-radius: 0.25rem;\n  width: 100%;\n}\n::v-deep(.htmlContent) p:last-of-type {\n  margin-bottom: 0;\n}\ncaption {\n  caption-side: top;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
